<template>
  <div class="asc-spinner-wrapper">
    <template v-if="!loading">
      <slot></slot>
    </template>
    <asc-spinner
      v-if="loading"
      class="asc-spinner-wrapper--spinner"
      :loading="loading"
    ></asc-spinner>
  </div>
</template>

<script>
import AscSpinner from './AscSpinner'

export default {
  name: 'AscSpinnerWrapper',

  components: {
    AscSpinner,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.asc-spinner-wrapper {
  &--spinner {
    margin: 40px 0 !important;
  }
}
</style>
